export default __webpack_public_path__ + "static/media/explain.582c6019.png";